import { render, staticRenderFns } from "./SearchTreatmentSetting.vue?vue&type=template&id=295d75e3&scoped=true"
import script from "./SearchTreatmentSetting.vue?vue&type=script&lang=js"
export * from "./SearchTreatmentSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "295d75e3",
  null
  
)

export default component.exports